// extracted by mini-css-extract-plugin
module.exports = {"Root":"Marker_Root__5AUN7","IsClickable":"Marker_IsClickable__5k12Z","ComingSoon":"Marker_ComingSoon__eRPbm"};